import * as type from '../../ActionTypes';

export function patchPaymentFixedRecords(payload: any, proposalId: any, jobId: any) {
  return {
    type: type.PATCH_PAYMENT_FIXED_REQUEST,
    payload,
    proposalId,
    jobId
  };
}

export function patchPaymentTimesheetRecords(payload: any, id: any, contractID: any) {
  return {
    type: type.PATCH_PAYMENT_TIMESHEET_REQUEST,
    payload,
    id,
    contractID
  };
}

export function setPaymentOnBoard() {
  return {
    type: type.PAYMENT_ONBOARD_SET
  };
}

export function reSetPaymentOnBoard() {
  return {
    type: type.PAYMENT_ONBOARD_RESET
  };
}
